import React from 'react'
import { Card, Image } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import Labels from './../../../../../common/Labels';
import EllipsisTooltip from './../../../../../common/EllipsisTooltip';
import momentDate from '../../../../../../helpers/momentDate';
import ActivityUserInfo from './../ActivityUserInfo';
import noImage from '../../../../../../images/common/broken-image.png'

import { Grid } from 'semantic-ui-react';
var moment = require('moment');
class InitaitveCard extends React.Component {


    async goToInitiative(id, data) {
        await dispatch.home.redirectFromEventStream(true);
        let pLoad = {
            id: id,
            data: data
        }
        await dispatch.initiatives.checkInitiatuiveAvailability(pLoad);
    }
    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    render() {
        const { data, initiativeOwnerDetails, selectedAccount, selectedOrganisation } = this.props;
        let currentDate = moment().format('YYYY-MM-DD');
        var initiativeEndDate = moment(data.entityData.endDate, "YYYY-MM-DD");
        let isInitiativeEndDelayed = moment.duration(initiativeEndDate.diff(currentDate)).asDays();

        return (
            <div className="StreamActivity" >
                {data.from ?
                    <ActivityUserInfo
                        user={data.from}
                        date={data.createdAt}
                        subCategory={data.subCategory}
                        data={data}
                        selectedAccount={selectedAccount}
                        selectedOrganisation={selectedOrganisation}

                    /> : ''}
                <div className="ActivityStreamContent" >
                    <div className="streamCard"
                        onClick={() => this.goToInitiative(data.entityId, data.entityData)}
                    >
                        <div className="imageBlock">
                            <Card className="appDefaultCard ">
                                <Card.Header>
                                    <EllipsisTooltip
                                        name={data.entityData.name}
                                    />
                                </Card.Header>
                                <Card.Content >
                                    <Image onError={this.addDefaultSrc} className="fitImage" src={data.entityData.picture} />
                                    {data.entityData.status === 1 && data.entityData.totalIssueCount > 0 ?
                                        <div className="badge badgeIssue">Issue </div> :
                                        data.entityData.status === 1 && (isInitiativeEndDelayed) < 0 ?
                                            <div className="badge badgeCaution">Delayed </div> :
                                            data.entityData.status === 1 && data.entityData.totalActivityCount !== data.entityData.totalCompletedCount
                                                && (data.entityData.totalInProgressCount > 0 || data.entityData.totalCompletedCount > 0) ?
                                                <div className="badge badgeOnTrack">In Progress </div> :
                                                data.entityData.status === 1 && data.entityData.totalInProgressCount === 0 ?
                                                    <div className="badge badgeNotStarted">Not Started </div> : ""

                                    }
                                    {data.entityData.status === -1 && <div className="badge badgeDraft">Draft </div>}
                                    {data.entityData.status === 0 && <div className="badge badgeIndesign">In Design </div>}
                                    {data.entityData.status === 2 && <div className="badge badgeCompleted">Completed </div>}
                                    {data.entityData.status === 3 && <div className="badge badgeClosed">Closed </div>}
                                    {data.entityData.status === 4 && <div className="badge badgeInEdit">Editing</div>}
                                    {data.entityData.status === 5 && <div className="badge badgeCanceled">Cancelled</div>}
                                </Card.Content>
                            </Card>
                        </div>
                        <div className="contentBlock">
                            <Grid columns='equal'>
                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels name="Start Date" text={momentDate(data.entityData.startDate)} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels name="End Date" text={momentDate(data.entityData.endDate)} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels name="Days " text={data.entityData.totaldays} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>

                                    <Grid.Column >
                                        {data.entityData.teamId.id === data.organizationId ?
                                            <Labels
                                                name="Initiative Execution"
                                                text={<span>Workspace Level</span>} />
                                            :
                                            <Labels
                                                name="Initiative Execution"
                                                text={<span>Team Level</span>} />
                                        }
                                    </Grid.Column>
                                    <Grid.Column >

                                        {data.entityData.teamId.id === data.organizationId ?
                                            <Labels
                                                name=" Workspace Name"
                                                text={
                                                    <EllipsisTooltip name={this.props.selectedOrganisation.name} />}
                                            />
                                            :
                                            <Labels
                                                name="Team Name"
                                                text={
                                                    <EllipsisTooltip name={data.entityData.teamId.name} />} />
                                        }
                                    </Grid.Column>
                                    <Grid.Column >
                                        {data.entityData.createdBy && data.entityData.createdBy.firstName ?
                                            <Labels
                                                name="Owner"
                                                text={
                                                    <div>
                                                        {<EllipsisTooltip name={<span>{data.entityData.createdBy.firstName} {data.entityData.createdBy.lastName}</span>} />}
                                                    </div>
                                                }
                                            /> : null
                                        }
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels
                                            name="Description"
                                            text={<EllipsisTooltip name={data.entityData.description}
                                                line={2}
                                                position="right center"
                                                ReadMore={true}
                                                htmlView={true}
                                                stripHtml={true}
                                            />}
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InitaitveCard;